(() => {
  window.addEventListener('load', () => {
    const ProductModal = customElements.get('product-modal');

    if (!ProductModal) {
      console.warn('[product-modal] Keine bestehende Komponente gefunden – kein Patch nötig.');
      return;
    }

    // Nur erweitern, keine neue Klasse definieren!
    if (!ProductModal.prototype.showActiveMedia) {
      ProductModal.prototype.showActiveMedia = function () {
        try {
          const opener = this.openedBy;
          if (!opener) return;

          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${opener.getAttribute('data-media-id')}"])`
          ).forEach((el) => el.classList.remove('active'));

          const activeMedia = this.querySelector(
            `[data-media-id="${opener.getAttribute('data-media-id')}"]`
          );
          if (!activeMedia) return;

          const tpl = activeMedia.querySelector('template');
          const content = tpl ? tpl.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

          const container = this.querySelector('[role="document"]');
          if (container && activeMedia.width) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            content &&
            content.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        } catch (err) {
          console.warn('[product-modal patch error]', err);
        }
      };
      console.debug('[product-modal] showActiveMedia ergänzt ⚙️');
    } else {
      console.debug('[product-modal] Bereits korrekt definiert ✅');
    }
  });
})();


